export type CreateRunErrorKind = 'duplicate_identifier' | 'totem_unlock_required' | 'unknown'

interface AxiosLikeError {
  response?: {
    status?: number
    data?: {
      error?: string
      errors?: Record<string, unknown>
    }
  }
}

export const classifyCreateRunError = (error: unknown): CreateRunErrorKind => {
  const response = (error as AxiosLikeError)?.response

  if (response?.status === 403 && response.data?.error === 'totem_unlock_required') {
    return 'totem_unlock_required'
  }

  if (response?.data?.errors?.email || response?.data?.errors?.registration_number) {
    return 'duplicate_identifier'
  }

  return 'unknown'
}
